import { render } from "./SelectRegionLayout.vue?vue&type=template&id=2f9648f2&scoped=true"
import script from "./SelectRegionLayout.vue?vue&type=script&lang=js"
export * from "./SelectRegionLayout.vue?vue&type=script&lang=js"

import "./SelectRegionLayout.vue?vue&type=style&index=0&id=2f9648f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9648f2"]])

export default __exports__